<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <div class="customer-tab">
        <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
          <div class="tab-text">
            <vx-card>
              <vs-table
                :max-items="descriptionItems[0]"
                pagination
                :data="goods"
                @selected="handleSelected"
                description
                search
                :description-items="descriptionItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("inventory.label.header") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Goods Receipt' })"
                      size="small"
                      >{{
                        $t("inventory.label.Create Goods Receipt")
                      }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("inventory.label.id") }}</vs-th>
                  <vs-th>{{ $t("inventory.label.Purchase Date") }}</vs-th>
                  <vs-th>{{ $t("inventory.label.Supplier Code") }}</vs-th>
                  <vs-th>{{
                    $t("inventory.label.business_entity_name")
                  }}</vs-th>
                  <vs-th>{{ $t("inventory.label.Item Description") }}</vs-th>
                  <vs-th>{{ $t("inventory.label.Ordered Quantity") }}</vs-th>
                  <vs-th>{{ $t("inventory.label.Received Quantity") }}</vs-th>
                  <vs-th>{{ $t("inventory.label.Balance Quantity") }}</vs-th>
                  <vs-th>{{ $t("inventory.label.status") }}</vs-th>
                  <vs-th>{{ $t("inventory.label.action") }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="good"
                    v-for="(good, index) in data"
                  >
                    <vs-td :data="good.id">{{ good.id }}</vs-td>
                    <vs-td :data="getDate(good.purchaseDate)">{{
                      getDate(good.purchaseDate)
                    }}</vs-td>
                    <vs-td :data="good.supplierName">{{
                      good.supplierName
                    }}</vs-td>
                    <vs-td :data="good.officeName">{{ good.officeName }}</vs-td>
                    <vs-td :data="good.itemDescription">{{
                      good.itemDescription
                    }}</vs-td>
                    <vs-td :data="good.orderdQuantity">{{
                      good.orderdQuantity
                    }}</vs-td>
                    <vs-td :data="good.receivedQuantity">{{
                      good.receivedQuantity
                    }}</vs-td>
                    <vs-td :data="good.balanceQuantity">{{
                      good.balanceQuantity
                    }}</vs-td>
                    <vs-td :data="good">
                      <vs-chip
                        :color="
                          getOrderStatusColor(
                            good.orderdQuantity == good.receivedQuantity
                              ? 'Completed'
                              : 'Pending'
                          )
                        "
                        class="product-order-status"
                        >{{
                          good.orderdQuantity == good.receivedQuantity
                            ? "Completed"
                            : "Pending"
                        }}
                      </vs-chip>
                    </vs-td>
                    <vs-td :data="good" class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('inventory.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          v-show="
                            good.orderdQuantity == good.receivedQuantity
                              ? false
                              : true
                          "
                          @click.stop="editData(good.id)"
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>
        </div>
      </div>

      <ConfirmDelete
        :title="deletePopupTitle"
        :isOpen="deleteItemPopup"
        @onCancel="deleteItemPopup = false"
        @onConfirm="deleteTeamTransfer(type, delId)"
      />
    </div>
  </div>
</template>
<script>
import {
  editGrnTemplate,
  viewGRVStockTransfer,
  getSqlSearch,
  getByItemDetailsTemplate,
  getByItemDetailsdropdown,
  deleteItemDetail,
  saveQuality,
  getMrnHistory,
  viewMRNStockTransfer,
  deleteItemSale,
} from "@/http/inventory";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Vendors from "./Vendors/Index.vue";
import Assets from "./Assets/Index.vue";
import confirmDelete from "@/components/common/confirmDelete";
import { mapState } from "vuex";

export default {
  components: {
    AtomSpinner,
    vSelect,
    ValidationObserver,
    ValidationProvider,
    Vendors,
    Assets,
    ConfirmDelete: confirmDelete,
  },
  data() {
    return {
      loading: false,
      editGrnPopup: false,
      resetKey: 0,
      searchOption: 0,
      purchaseDate: "",
      editOrderQty: 0,
      deleteItemPopup: false,
      selectedName: "",
      selectedDescription: "",
      selectedStatus: "",
      saveGrnPayload: {
        purchaseDate: "",
        orderdQuantity: "",
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        purchaseNo: "",
        supplierId: "",
        officeId: "",
        itemMasterId: "",
      },
      descriptionItems: [10, 20, 30],
      value: ["Inactive", "New", "Success"],
      grn: {},
      goods: [],
      searches: [],
      updateCraditPopup: false,
      updateCraditPopup1: false,
      editJobsPopup: false,
      details: {},
      detail: {
        quality: "",
        serialNumber: "",
        provisioningSerialNumber: "",
      },
      qualityDatas: [],
      historys: {
        fromOffice: "",
        itemDescription: "",
      },
      history: [],
      stockTransferData: [],
      popupDeleteStockTransfer: false,
      showBtnRadioTransfer: "Item",
      type: "",
      deletePopupTitle: "",
    };
  },

  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      filteredStockList: (state) => state.inventory.filteredStock,
    }),
  },
  methods: {
    editData(id) {
      this.$router.push({ name: "Edit Goods Receipt", params: { id: id } });
    },
    handleSelected(good) {
      this.$router.push({
        name: "View Goods Receipt",
        params: { id: good.id },
      });
    },

    getOrderStatusColor(status) {
      if (status === "Pending") return "orange";
      return "success";
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    async viewGRVStockTransfer() {
      this.loading = true;
      try {
        const good = await viewGRVStockTransfer();
        this.goods = good.data.pageItems;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
  },
  mounted() {
    this.viewGRVStockTransfer();
  },
  watch: {
    editGrnPopup(newValue) {
      if (newValue) {
        this.viewGRVStockTransfer();
      }
    },
  },
};
</script>
<style scoped>
.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  margin: 0 auto;
  border: 1px solid #c5d0df;
  border-radius: 6px;
}
.inventory_tabSec >>> .vs-tabs-primary .con-ul-tabs .line-vs-tabs {
  background: linear-gradient(
    118deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.7)
  ) !important;
  box-shadow: none !important;
}
.inventory_tabSec >>> .vs-tabs-primary .con-ul-tabs .activeChild button {
  color: #fff !important;
}
.inventory_tabSec >>> .activeChild button.vs-tabs--btn {
  background: linear-gradient(
    118deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.7)
  );
  padding-top: 10px;
  padding-bottom: 10px;
}

.inventory_tabSec >>> .vs-tabs--ul {
  padding-top: 0;
}
.inventory_tabSec >>> .vs-tabs-position-top .vs-tabs--ul {
  width: 100%;
}
.inventory_tabSec >>> .vs-tabs--li {
  display: inline-block !important;
  width: 33.33% !important;
}
.inventory_tabSec >>> .vs-tabs--li button.vs-tabs--btn span {
  text-transform: uppercase;
}
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}
.header-dropdown1 {
  min-width: 180px !important;
}
.header-dropdown2 {
  min-width: 195px !important;
}
.header-dropdown3 {
  min-width: 150px !important;
}
::v-deep .vs-table--search-input {
  width: 150px !important;
}
</style>
